import { AxiosInstance } from 'axios';
import { G00D00MockAPI } from './group/g00/g00-d00/restapi';
import { createAPIInstance } from '@/context/global/utils/api/api-create';
import { PageAPI } from '@/context/global/api/group/page/restapi';
import { UserAPI } from '@/context/global/api/group/user/restapi';
import { SongAPI } from '@/context/global/api/group/song/restapi';
import { AuthAPI } from '@/context/global/api/group/auth/restapi';

export const CreateAPI = (axios: AxiosInstance) => {
  return {
    G00D00Example: G00D00MockAPI(axios),
    Page: PageAPI(axios),
    User: UserAPI(axios),
    Song: SongAPI(axios),
    Auth: AuthAPI(axios),
  };
};

export const apiClient = createAPIInstance({});

CreateAPI(apiClient);
